import * as yup from "yup";

export const indexBaseSchema = yup.object().shape({
  name: yup.string().required("Please Select Index Name"),
  type: yup.string().required(),
  format: yup
    .string()
    .test("is-format-exist", "format is required", (value, testContext) => {
      const { parent } = testContext;
      return !(parent.type === "Date" && !value);
    }),
  required: yup.bool(),
  defaultIndex: yup.bool(),
  editable: yup.bool(),
  availableInIS: yup.bool(),
  tags: yup.array().of(yup.string()),
});

export const getIndexListSchema = (indexes) =>
  yup.object().shape({
    formData: yup.array().of(
      yup.object().shape({
        ...indexBaseSchema.fields,
        name: yup
          .string()
          .required("Please Select Index Name")
          .test(
            "is-index-name-already-exist",
            "Index Name already exist",
            (value) => {
              return (
                indexes.findIndex(
                  (index) =>
                    index.name.toUpperCase().trim() ===
                    value.toUpperCase().trim(),
                ) === -1
              );
            },
          )
          .test(
            "is-index-name-duplicated",
            "Index Name duplicated",
            (value, testContext) => {
              const { from } = testContext;
              return !(
                from[1].value.formData.filter(
                  (index) =>
                    index.name.toUpperCase().trim() ===
                    value.toUpperCase().trim(),
                ).length > 1
              );
            },
          ),
      }),
    ),
  });

export default {
  indexBaseSchema,
  getIndexListSchema,
};
